import React from 'react';
import { TableRow } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { StyledTableCellProps as StyledTableCell, StyledTooltip } from '../../commons/utils/TableStyles';
import Security from '../../commons/security/Security.js';
import Timezone from '../../commons/timezone/Timezone.js';
import { CLASE_SEMAFORO, etiquetaEstado } from './solicitudEstado.js';

const LARGO_DETALLE = 40;

const SolicitudesGridRow = ({ solicitud, columnas, onVer, onVerDetalle, onVerAdjuntos, onCancelar, onRechazar }) => {
	const intl = useIntl();
	const detalleLargo = Boolean(solicitud.detalle) && solicitud.detalle.length > LARGO_DETALLE;

	const paralizado = () => {
		if (solicitud.inmovilizado === null) return '';
		return solicitud.inmovilizado
			? <span className="text-danger">{intl.formatMessage({ id: 'correctivosAbm.inmovilizadoOptions.si', defaultMessage: 'SI' })}</span>
			: intl.formatMessage({ id: 'correctivosAbm.inmovilizadoOptions.no', defaultMessage: 'NO' });
	};

	return (
		<TableRow>
			<StyledTableCell show={columnas.esVisible('numero')}>{solicitud.numero}</StyledTableCell>
			<StyledTableCell className={CLASE_SEMAFORO[solicitud.estado] || 'status-grey'} />
			<StyledTableCell show={columnas.esVisible('estado')}>{etiquetaEstado(intl, solicitud.estado)}</StyledTableCell>
			<StyledTableCell show={columnas.esVisible('fecha')}>
				{Timezone.getDateForClient(solicitud.fechaHora, null, 'DD/MM/YYYY HH:mm')}
			</StyledTableCell>
			<StyledTableCell show={columnas.esVisible('solicitante')}>{solicitud.solicitante}</StyledTableCell>
			<StyledTableCell show={columnas.esVisible('entidad')}>{solicitud.dominio}</StyledTableCell>
			<StyledTableCell show={columnas.esVisible('inmovilizado')}>{paralizado()}</StyledTableCell>
			<StyledTableCell show={columnas.esVisible('base')}>{solicitud.base}</StyledTableCell>
			<StyledTableCell show={columnas.esVisible('detalle')}>
				{detalleLargo ? solicitud.detalle.substring(0, LARGO_DETALLE) + '…' : solicitud.detalle}
				{detalleLargo && (
					<StyledTooltip title={intl.formatMessage({ id: 'solicitudesGrid.detalle.ver_completo', defaultMessage: 'Ver detalle completo' })} arrow placement="top">
						<button type="button" className="action btn btn-sm btn-icon btn-dt-grid text-success" aria-label={intl.formatMessage({ id: 'solicitudesGrid.detalle.ver_completo', defaultMessage: 'Ver detalle completo' })} onClick={() => onVerDetalle(solicitud)}>
							<i className="la la-comment" />
						</button>
					</StyledTooltip>
				)}
			</StyledTableCell>
			<StyledTableCell show={columnas.esVisible('adjuntos')}>
				{solicitud.cantidadAdjuntos > 0 ? (
					<StyledTooltip title={intl.formatMessage({ id: 'solicitudesGrid.adjuntos.ver', defaultMessage: 'Ver adjuntos' })} arrow placement="top">
						<button type="button" className="btn btn-sm btn-link p-0 text-success" aria-label={intl.formatMessage({ id: 'solicitudesGrid.adjuntos.ver', defaultMessage: 'Ver adjuntos' })} onClick={() => onVerAdjuntos(solicitud)}>
							<i className="la la-paperclip" /> {solicitud.cantidadAdjuntos}
						</button>
					</StyledTooltip>
				) : (
					<span className="text-muted"><i className="la la-paperclip" /> 0</span>
				)}
			</StyledTableCell>
			<StyledTableCell show={columnas.esVisible('ticket')}>
				{solicitud.ticketId ? <a href={'/tickets/' + solicitud.ticketId + '/edit'}>{'#' + solicitud.ticketId}</a> : '—'}
			</StyledTableCell>
			<StyledTableCell align="center">
				<div className="d-inline-flex">
					<StyledTooltip title={intl.formatMessage({ id: 'solicitudesGrid.acciones.ver', defaultMessage: 'Ver' })} arrow placement="top">
						<button type="button" className="action btn btn-sm btn-icon btn-dt-grid text-success" aria-label={intl.formatMessage({ id: 'solicitudesGrid.acciones.ver', defaultMessage: 'Ver' })} onClick={() => onVer(solicitud)}>
							<i className="fa fa-search fa-xs" />
						</button>
					</StyledTooltip>
					{solicitud.estado === 'PENDIENTE' && Security.hasPermission('SOLICITUDES_GESTIONAR') && (
						<StyledTooltip title={intl.formatMessage({ id: 'solicitudesGrid.acciones.liberar', defaultMessage: 'Liberar a correctivo' })} arrow placement="top">
							<button type="button" className="action btn btn-sm btn-icon btn-dt-grid text-success" aria-label={intl.formatMessage({ id: 'solicitudesGrid.acciones.liberar', defaultMessage: 'Liberar a correctivo' })}>
								<i className="fa fa-arrow-circle-right fa-xs" />
							</button>
						</StyledTooltip>
					)}
					{solicitud.estado === 'PENDIENTE' && Security.hasPermission('SOLICITUDES_GESTIONAR') && (
						<StyledTooltip title={intl.formatMessage({ id: 'solicitudesGrid.acciones.rechazar', defaultMessage: 'Rechazar' })} arrow placement="top">
							<button type="button" className="action btn btn-sm btn-icon btn-dt-grid text-danger" aria-label={intl.formatMessage({ id: 'solicitudesGrid.acciones.rechazar', defaultMessage: 'Rechazar' })} onClick={() => onRechazar(solicitud)}>
								<i className="fa fa-times-circle fa-xs" />
							</button>
						</StyledTooltip>
					)}
					{solicitud.puedeCancelar && (
						<StyledTooltip title={intl.formatMessage({ id: 'solicitudesGrid.acciones.cancelar', defaultMessage: 'Cancelar solicitud' })} arrow placement="top">
							<button type="button" className="action btn btn-sm btn-icon btn-dt-grid text-danger" aria-label={intl.formatMessage({ id: 'solicitudesGrid.acciones.cancelar', defaultMessage: 'Cancelar solicitud' })} onClick={() => onCancelar(solicitud)}>
								<i className="fa fa-ban fa-xs" />
							</button>
						</StyledTooltip>
					)}
				</div>
			</StyledTableCell>
		</TableRow>
	);
};

export default SolicitudesGridRow;
